import { produce } from 'immer'

// Action Types
export const SET_SCHEDULED_CALLS = 'outbound/setScheduledCalls'
export const SET_SCHEDULED_CALLS_LOADING = 'outbound/scheduledCalls/setLoading'

// Action Creators
export const setScheduledCalls = (payload) => ({
  type: SET_SCHEDULED_CALLS,
  payload,
})

export const setLoading = (payload) => ({
  type: SET_SCHEDULED_CALLS_LOADING,
  payload,
})

// State
export const initialState = {
  data: {
    scheduledCalls: [],
    total: 0,
    offset: 0,
  },
  loading: {
    scheduledCalls: false,
  },
}

// Reducer
export default function outboundScheduledCallsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_SCHEDULED_CALLS_LOADING:
        newState.loading = { ...newState.loading, ...payload }
        break
      case SET_SCHEDULED_CALLS:
        newState.data.scheduledCalls = payload.scheduled_calls || []
        newState.data.total = payload.total || 0
        newState.data.offset = payload.offset || 0
        break
      default:
        break
    }
  })
}
